export default __webpack_public_path__ + "static/media/fondo-hablanos-home.ce2e4ecd.png";